module.exports = __webpack_public_path__ + "static/img/printkupdownload1.950431f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/printkupdownload1.png
// module id = HfZu
// module chunks = 0